export default __webpack_public_path__ + "static/media/(40).34a9ba13.jpg";